import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {Provider} from "react-redux";
import {Normalize} from "styled-normalize";
import {ThemeProvider} from "styled-components";
import {ConfigProvider} from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';
import 'moment/locale/ru';
import App from 'App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import GlobalStyle from "components/GlobalStyle/GlobalStyle";
import {store} from "store/store";
import ErrorFallback from "./components/ErrorFallback/ErrorFallback";
import {ErrorBoundary} from "react-error-boundary";
import { DragContextProvider } from 'components/drag';

moment.locale('ru');

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={persistor}> */}
            <ConfigProvider locale={ruRU}>
                <DragContextProvider>
                    <ThemeProvider theme={theme}>
                        <GlobalStyle/>
                        <Normalize/>
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <App/>
                        </ErrorBoundary>
                    </ThemeProvider>
                </DragContextProvider>
            </ConfigProvider>
            {/* </PersistGate> */}
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
